var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skeleton-item-welfare",class:( _obj = {}, _obj[_vm.className] = _vm.className, _obj )})}
var staticRenderFns = []

export { render, staticRenderFns }